import ApiHelper from '../../ApiHelper';
import API_ENDPOINTS from '../../endpoints';

class SMENotificationHelper{

    async getNotifications(data) {
        try {
          const response = await ApiHelper.get(API_ENDPOINTS.SME.NOTIFICATIONS.BASE, data);
          return response;
        } catch (error) {
          throw new Error(`Failed to fetch notifications: ${error.message}`);
        }
    }

    async getNotificationById(id) {
        try {
          const response = await ApiHelper.get(`${API_ENDPOINTS.SME.NOTIFICATIONS.BY_ID(id)}`);
          return response;
        } catch (error) {
          throw new Error(`Failed to fetch notification: ${error.message}`);
        }
    }

    async sendNotification(data) {
        try {
          const response = await ApiHelper.post(API_ENDPOINTS.SME.NOTIFICATIONS.SEND, data);
          return response;
        } catch (error) {
          throw new Error(`Failed to send notification: ${error.message}`);
        }
    }
    async deleteNotification(id) {
        try {
          const response = await ApiHelper.delete(API_ENDPOINTS.SME.NOTIFICATIONS.DELETE(id));
          return response;
        } catch (error) {
          throw new Error(`Failed to delete notification: ${error.message}`);
        }
    }

    async getCourses(){
        try {
          const response = await ApiHelper.get(API_ENDPOINTS.SME.COURSES);
          return response;
        } catch (error) {
            throw new Error(`Failed to fetch courses: ${error.message}`);
        }
    }

    async getCollegesByCourse(courseId){
        try {
          const response = await ApiHelper.get(API_ENDPOINTS.SME.COLLEGEBYCOURSE(courseId));
          return response;
        } catch (error) {
            throw new Error(`Failed to fetch colleges: ${error.message}`);
        }
    }
}
export default new SMENotificationHelper();